import { cn } from '@/lib/utils'

/**
 * Scroll container for a desktop screen rendered inside `DesktopShell`. Provides
 * the full-height scroll and page padding. Content is capped at 1140px
 * (1204px minus the 32px gutters) and centered within the main area.
 */
export function DesktopPage({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div className="h-full overflow-y-auto">
      <div
        className={cn('mx-auto flex w-full max-w-[1204px] flex-col gap-6 px-8 py-8', className)}
      >
        {children}
      </div>
    </div>
  )
}
